const testimonials = [
  {
    user: "BhajanLal Sir",
    testimonial:
      "It is not just a football club, It's a community which helps young talent with education scholarships as well.",
  },
  {
    user: "Pankaj",
    testimonial:
      "The best 100%. Football training is one of the best things of TSS Club",
  },
  {
    user: "Gautam",
    testimonial:
      "A place for all ages, events are definitely the best, totally worth it..",
  },
  {
    user: "Deepak",
    testimonial:
      "I love this place! Not too expensive, not boring, and woah the events",
  },
];

export default testimonials;
